import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled, { withTheme } from 'styled-components';
import Text from '../text/text.component.js';
import '../buttons/button.component.js';
import { generalBackground } from '../../theme/theme-style.js';
import '../../App.css.js';
import { textColorText } from '../../theme/text-theme.js';
import '../media/Img.js';
import { Icon as Icon$1 } from '../media/Icon.js';
var _excluded = ["style", "titleText", "icon", "textStyle", "theme", "isMobile"];
var Container = styled.div.withConfig({
  displayName: "faq-linkcomponent__Container",
  componentId: "sc-1nz5bc-0"
})(["display:flex;flex-direction:row;align-items:center;box-sizing:border-box;border-radius:24px;", ""], generalBackground);
var Icon = styled(Icon$1).withConfig({
  displayName: "faq-linkcomponent__Icon",
  componentId: "sc-1nz5bc-1"
})(["", ""], textColorText);
var FaqLink = function FaqLink(_ref) {
  var style = _ref.style,
    titleText = _ref.titleText,
    icon = _ref.icon;
  _ref.textStyle;
  _ref.theme;
  var isMobile = _ref.isMobile,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Container, _extends({
    color: "grayEight",
    style: style
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: isMobile ? "24px" : "32px",
      boxSizing: "border-box"
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    icon: icon,
    color: "default",
    fontSize: "24px"
  }), /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: "euclid",
    type: "heading",
    fontSize: isMobile ? "largeB" : "medium",
    style: {
      marginLeft: isMobile ? "24px" : "34px"
    }
  }, titleText)));
};
var faqLink_component = withTheme(FaqLink);
export { faqLink_component as default };